import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRescheduleHosts = async (id) => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `productivity-host/reschedule/host/${id}`,
  });

  return data?.data;
};

export default getRescheduleHosts;
